// header_nav.ts
import CustomHeaderNavGroup from "../../components/base/custom-header-nav/CustomHeaderNavGroup";
import CustomHeaderNavItem from "../../components/base/custom-header-nav/CustomHeaderNavItem";
import CustomHeaderNavItemTitle from "../../components/base/custom-header-nav/CustomHeaderNavGroupTitle";

import CustomMenuGroup from "../../components/base/custom-menu/CustomMenuGroup";
import CustomMenuItem from "../../components/base/custom-menu/CustomMenuItem";

import {
  FaCubes,
  FaCube,
  FaServer,
  FaStream,
  FaTools,
  FaNetworkWired,
} from "react-icons/fa";

// Common data structure (UI-agnostic)
const headerNavRaw = [
  {
    name: "Products",
    groups: [
      {
        title: "UI Frameworks & Libraries",
        items: [
          {
            name: "elseware UI",
            to: "/education/academics",
            icon: FaCubes,
            description: "React UI components for modern web apps",
          },
          {
            name: "elseware JS",
            to: "/education/certifications",
            icon: FaCube,
            description: "Modular Node.js utilities for backend systems",
          },
        ],
      },
      {
        title: "Container Orchestration",
        items: [
          {
            name: "Crewmen",
            to: "/education/certifications",
            icon: FaServer,
            description: "Custom container orchestration system",
          },
          {
            name: "MockNet",
            to: "/education/certifications",
            icon: FaStream,
            description: "Simulated data clusters for testing and mining",
          },
          {
            name: "Bridge",
            to: "/education/certifications",
            icon: FaNetworkWired,
            description: "Pipeline for Crewmen and MockNet integration",
          },
        ],
      },
    ],
  },
  {
    name: "Solutions",
    groups: [
      {
        items: [
          {
            name: "UI Tools",
            to: "/projects/software",
            icon: FaTools,
            description: "Toolkits for building polished UIs",
          },
          {
            name: "Microservices",
            to: "/projects/game",
            icon: FaServer,
            description: "Tools for building and deploying microservices",
          },
          {
            name: "Orchestration",
            to: "/projects/game",
            icon: FaStream,
            description: "Smart container management tools",
          },
        ],
      },
    ],
  },
  {
    name: "Enterprise",
    to: "/enterprise",
  },
  {
    name: "Career",
    to: "/career",
  },
  {
    name: "About",
    to: "/about",
  },
  {
    name: "Contact",
    to: "/contact",
  },
];

// 🖥️ Desktop variant
export const getDesktopData = () => {
  return headerNavRaw.map((section) => {
    if (section.groups) {
      return {
        component: CustomHeaderNavGroup,
        name: section.name,
        items: section.groups
          .flatMap((group) => [
            group.title && {
              component: CustomHeaderNavItemTitle,
              name: group.title,
            },
            ...group.items.map((item) => ({
              component: CustomHeaderNavItem,
              name: item.name,
              to: item.to,
              icon: <item.icon />,
              description: item.description,
            })),
          ])
          .filter(Boolean),
      };
    } else {
      return {
        component: CustomHeaderNavGroup,
        name: section.name,
        to: section.to,
      };
    }
  });
};

// 📱 Mobile variant
export const getMobileData = () => {
  return headerNavRaw.map((section) => {
    if (section.groups) {
      return {
        component: CustomMenuGroup,
        name: section.name,
        items: section.groups
          .flatMap((group) => [
            group.title && {
              component: CustomHeaderNavItemTitle,
              name: group.title,
            },
            ...group.items.map((item) => ({
              component: CustomMenuItem,
              name: item.name,
              to: item.to,
              icon: <item.icon />,
              description: item.description,
            })),
          ])
          .filter(Boolean),
      };
    } else {
      return {
        component: CustomMenuItem,
        name: section.name,
        to: section.to,
      };
    }
  });
};

// Exporting the data
export const headerNavDesktopData = getDesktopData();
export const headerNavMobileData = getMobileData();
